<div mat-dialog-content>
    <p>{{labels.lblWrongLoginData}}</p>
  </div>
<div mat-dialog-actions>
    <button mat-button class="tableBtn" (click)="onNoClick()">{{labels.lblOk}}</button>
</div>
